"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadUrls = exports.downloadSampleBulkCsv = exports.downloadCsv = void 0;
var file_saver_1 = require("file-saver");
var Sentry = __importStar(require("@sentry/react"));
var actions_1 = __importDefault(require("../components/pages/RootPage/actions"));
var actions_2 = __importDefault(require("../../user/actions"));
var ie_1 = __importDefault(require("../components/BaseLayout/util/ie"));
var ga_1 = require("./ga");
var urlQueryHelper_1 = __importDefault(require("../helpers/urlQueryHelper"));
var constants_1 = require("../../../shared/constants");
var isDgSuperApp_1 = __importDefault(require("./isDgSuperApp"));
var blobToBase64_1 = __importDefault(require("../../user/helpers/blobToBase64"));
var dg_super_app_bridge_1 = require("../../shared/dg-super-app-bridge");
var downloadCsv = function (csvString, filename) { return __awaiter(void 0, void 0, void 0, function () {
    var blob, base64, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                blob = new Blob([csvString], {
                    type: 'text/csv;charset=utf-8',
                });
                if (!ie_1.default()) return [3 /*break*/, 1];
                navigator.msSaveBlob(blob, filename);
                return [3 /*break*/, 8];
            case 1:
                if (!isDgSuperApp_1.default()) return [3 /*break*/, 7];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, , 6]);
                return [4 /*yield*/, blobToBase64_1.default(blob)];
            case 3:
                base64 = _a.sent();
                return [4 /*yield*/, dg_super_app_bridge_1.saveResource(filename, base64, 'anyFile', 'csv')];
            case 4:
                _a.sent();
                return [3 /*break*/, 6];
            case 5:
                e_1 = _a.sent();
                console.log(e_1);
                return [3 /*break*/, 6];
            case 6: return [3 /*break*/, 8];
            case 7:
                file_saver_1.saveAs(blob, filename);
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}); };
exports.downloadCsv = downloadCsv;
var downloadSampleBulkCsv = function () {
    var headers = constants_1.BULK_UPLOAD_HEADER;
    var body = [
        ['https://www.link1.com', 'shorturl1', 'tag1'],
        ['https://www.link2.com', 'shorturl2', 'tag2'],
    ];
    var content = __spreadArray([headers], __read(body)).join('\r\n');
    exports.downloadCsv(content, 'sample_bulk.csv');
    ga_1.GAEvent('modal page', 'downloaded bulk sample', 'successful');
};
exports.downloadSampleBulkCsv = downloadSampleBulkCsv;
var downloadUrls = function (tableConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var urlsArr, queryObj, _a, json, isOk, urls;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                urlsArr = [];
                // set headers to csv
                urlsArr.push([
                    'Short URL',
                    'Original URL',
                    'Status',
                    'Tags',
                    'Visits',
                    'Created At',
                    'Last Modified\n',
                ]);
                queryObj = urlQueryHelper_1.default(tableConfig);
                return [4 /*yield*/, actions_2.default.getUrls(queryObj)];
            case 1:
                _a = _b.sent(), json = _a.json, isOk = _a.isOk;
                if (isOk) {
                    urls = json.urls;
                    urls.forEach(function (url) {
                        var shortUrl = url.shortUrl, longUrl = url.longUrl, state = url.state, tagStrings = url.tagStrings, clicks = url.clicks, createdAt = url.createdAt, updatedAt = url.updatedAt;
                        //  eslint-disable-next-line prefer-template
                        urlsArr.push([
                            shortUrl,
                            longUrl,
                            state,
                            tagStrings,
                            clicks,
                            createdAt,
                            updatedAt + "\n",
                        ]);
                    });
                }
                else if (!isOk && json) {
                    // Sentry analytics: download links fail
                    Sentry.captureMessage('download links unsuccessful');
                    ga_1.GAEvent('user page', 'download links', 'unsuccessful');
                    actions_1.default.setErrorMessage(json.message || '');
                    return [2 /*return*/, null];
                }
                else {
                    // Sentry analytics: download links fail
                    Sentry.captureMessage('download links unsuccessful');
                    ga_1.GAEvent('user page', 'download links', 'unsuccessful');
                    actions_1.default.setErrorMessage('Error downloading urls.');
                    return [2 /*return*/, null];
                }
                exports.downloadCsv(urlsArr.join(''), 'urls.csv');
                // Google Analytics: Download links button events
                ga_1.GAEvent('user page', 'download links button', 'successful');
                return [2 /*return*/, null];
        }
    });
}); };
exports.downloadUrls = downloadUrls;
exports.default = {
    downloadSampleBulkCsv: exports.downloadSampleBulkCsv,
    downloadUrls: exports.downloadUrls,
};
